import React from 'react';

import { SandboxEmbedCodeSnippetConfig } from './EmbedSandboxCodeSnippetConfig';
import { JSONOptionsSnippet } from './JSONOptionsSnippet';

export const VanillaNpmSnippet = (config: SandboxEmbedCodeSnippetConfig) => (
  <>
    {`import { ApolloSandbox } from '@apollo/sandbox';
  `}
    {`... 
  new ApolloSandbox(`}
    <JSONOptionsSnippet {...config} />
    {`);
  ...
  <div id="embedded-sandbox"/>`}
  </>
);
